'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactPortal = require('react-portal');

var _reactackleCore = require('reactackle-core');

var _DialogHeading = require('./DialogHeading');

var _DialogCloseButton = require('./DialogCloseButton');

var _DialogContent = require('./DialogContent');

var _DialogButton = require('./DialogButton');

var _DialogActions = require('./DialogActions');

var _ModalStyled = require('./styles/ModalStyled');

var _BackdropStyled = require('./styles/BackdropStyled');

var _OverflowWrapperStyled = require('./styles/OverflowWrapperStyled');

var _RegionMainStyled = require('./styles/RegionMainStyled');

var _RegionSideStyled = require('./styles/RegionSideStyled');

var _ContentWrapperStyled = require('./styles/ContentWrapperStyled');

var _theme = require('./styles/theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

(0, _reactackleCore.registerDefaultComponentTheme)('dialog', _theme2.default);

var ButtonType = _propTypes2.default.shape(_extends({}, _DialogButton.DialogButton.propTypes, {
  id: _propTypes2.default.number
}));

var propTypes = {
  /**
   * Determine whether to render backdrop
   */
  backdrop: _propTypes2.default.bool,

  /**
   * If set to true, the content of the Dialog will be scrollable
   */
  scrollable: _propTypes2.default.bool,

  /**
   * Determine whether to render dialog
   */
  open: _propTypes2.default.bool,

  /**
   * Determine whether to render close button
   */
  haveCloseButton: _propTypes2.default.bool,

  /**
   * Determine whether to close dialog on ESC key down
   */
  closeOnEscape: _propTypes2.default.bool,

  /**
   * Determine whether to close dialog on backdrop click
   */
  closeOnBackdropClick: _propTypes2.default.bool,

  /**
   * Title of the dialog
   */
  title: _propTypes2.default.string,

  /**
   * Subtitle of the dialog
   */
  subtitle: _propTypes2.default.string,

  /**
   * Buttons of the left side of the dialog
   */
  buttonsLeft: _propTypes2.default.arrayOf(ButtonType),

  /**
   * Buttons of the right side of the dialog
   */
  buttons: _propTypes2.default.arrayOf(ButtonType),

  /**
   * Minimum width of the dialog
   */
  minWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),

  /**
   * Padding size in the dialog
   */
  paddingSize: _propTypes2.default.oneOf(['none', 'default']),

  /**
   * Determine whether to render dialog in full window size
   */
  fullWindowSize: _propTypes2.default.bool,

  /**
   * Determine whether to render dialog with transparent background
   */
  transparentBg: _propTypes2.default.bool,

  /**
   * Determine whether to display dialog content in flex mode
   */
  dialogContentFlex: _propTypes2.default.bool,

  /**
   * Dialog aside element
   */
  regionAside: _propTypes2.default.element,

  /**
   * Dialog aside element max width
   */
  regionAsideMaxWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),

  /**
   * Determine whether to show dialog aside element in dialog
   */
  regionAsideShow: _propTypes2.default.bool,

  /**
   * @ignore
   */
  // eslint-disable-next-line react/require-default-props
  theme: _propTypes2.default.object,

  /**
   * Specify function to call on ENTER key press
   */
  onEnterKeyPress: _propTypes2.default.func,

  /**
   * Specify function to call on dialog close
   */
  onClose: _propTypes2.default.func,

  /**
   * Specify function to call just before dialog close
   */
  onBeforeClose: _propTypes2.default.func,

  /**
   * Determines whether to display already mounted dialog
   */
  visible: _propTypes2.default.bool
};
var defaultProps = {
  backdrop: false,
  scrollable: false,
  open: false,
  haveCloseButton: false,
  closeOnEscape: false,
  closeOnBackdropClick: false,
  title: '',
  subtitle: '',
  buttons: [],
  buttonsLeft: [],
  minWidth: 0,
  paddingSize: 'default',
  fullWindowSize: false,
  transparentBg: false,
  dialogContentFlex: false,
  regionAside: null,
  regionAsideMaxWidth: 150,
  regionAsideShow: false,
  onEnterKeyPress: _reactackleCore.noop,
  onClose: _reactackleCore.noop,
  onBeforeClose: _reactackleCore.noop,
  visible: true
};
var ESC = 27,
    ENTER = 13;

var _Dialog = function (_Component) {
  _inherits(_Dialog, _Component);

  function _Dialog(props) {
    _classCallCheck(this, _Dialog);

    var _this = _possibleConstructorReturn(this, (_Dialog.__proto__ || Object.getPrototypeOf(_Dialog)).call(this, props));

    _this.canHaveBackdrop = true;
    _this._keyboardListened = false;
    _this._backupBodyStyle = {
      height: null,
      overflowY: null
    };
    _this._handleBackdropClick = _this._handleBackdropClick.bind(_this);
    _this._handleKeyUp = _this._handleKeyUp.bind(_this);
    _this._handleDialogClose = _this._handleDialogClose.bind(_this);
    return _this;
  }

  _createClass(_Dialog, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._toggleKeyboardListener(this._isVisible());
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this._toggleKeyboardListener(this._isVisible(nextProps));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._toggleKeyboardListener(false);
    }
  }, {
    key: '_toggleKeyboardListener',
    value: function _toggleKeyboardListener(condition) {
      if (condition && !this._keyboardListened) {
        this._keyboardListened = true;
        document.body.addEventListener('keyup', this._handleKeyUp);
      } else if (!condition && this._keyboardListened) {
        this._keyboardListened = false;
        document.body.removeEventListener('keyup', this._handleKeyUp);
      }
    }
  }, {
    key: '_isVisible',
    value: function _isVisible() {
      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      return source.open && source.visible;
    }
  }, {
    key: '_handleDialogClose',
    value: function _handleDialogClose() {
      var willNotClose = this.props.onBeforeClose() === false;
      if (!willNotClose) this.props.onClose();
    }
  }, {
    key: '_handleBackdropClick',
    value: function _handleBackdropClick() {
      if (this.props.closeOnBackdropClick) this._handleDialogClose();
    }
  }, {
    key: '_handleKeyUp',
    value: function _handleKeyUp(event) {
      if (event.keyCode === ESC && this.props.closeOnEscape) this._handleDialogClose();else if (event.keyCode === ENTER) this.props.onEnterKeyPress(this._handleDialogClose);
    }
  }, {
    key: '_renderCloseButton',
    value: function _renderCloseButton() {
      if (!this.props.haveCloseButton) return null;
      return _react2.default.createElement(_DialogCloseButton.DialogCloseButton, {
        onClick: this._handleDialogClose,
        transparentBg: this.props.transparentBg
      });
    }
  }, {
    key: '_renderRegionAside',
    value: function _renderRegionAside() {
      if (!this.props.regionAside) return null;
      return _react2.default.createElement(_RegionSideStyled.RegionSideStyled, {
        regionAsideMaxWidth: this.props.regionAsideMaxWidth
      }, this.props.regionAside);
    }
  }, {
    key: '_renderButtonsLeft',
    value: function _renderButtonsLeft() {
      var _this2 = this;

      if (!this.props.buttonsLeft.length) return null;
      var buttonsLeftList = this.props.buttonsLeft.map(function (button, index) {
        return _react2.default.createElement(_DialogButton.DialogButton, _extends({}, button, {
          key: (0, _reactackleCore.getKey)(button, index),
          onCloseDialog: _this2._handleDialogClose
        }));
      });
      return _react2.default.createElement(_DialogActions.DialogActionsRegion, {
        alignLeft: true
      }, buttonsLeftList);
    }
  }, {
    key: '_renderButtons',
    value: function _renderButtons() {
      var _this3 = this;

      if (!this.props.buttons.length) return null;
      var buttonsList = this.props.buttons.map(function (button, index) {
        return _react2.default.createElement(_DialogButton.DialogButton, _extends({}, button, {
          key: (0, _reactackleCore.getKey)(button, index),
          onCloseDialog: _this3._handleDialogClose
        }));
      });
      return _react2.default.createElement(_DialogActions.DialogActionsRegion, null, buttonsList);
    }
  }, {
    key: '_renderActions',
    value: function _renderActions() {
      if (!this.props.buttons.length && !this.props.buttonsLeft.length) return null;

      var buttonsLeft = this._renderButtonsLeft(),
          buttons = this._renderButtons();

      return _react2.default.createElement(_DialogActions.DialogActions, null, buttonsLeft, buttons);
    }
  }, {
    key: '_renderBackdrop',
    value: function _renderBackdrop() {
      if (!this.canHaveBackdrop || !this.props.backdrop) return null;
      return _react2.default.createElement(_BackdropStyled.BackdropStyled, {
        onClick: this._handleBackdropClick
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var closeButton = this._renderCloseButton(),
          regionAside = this._renderRegionAside(),
          actions = this._renderActions(),
          backdrop = this._renderBackdrop();

      var followsHeading = !!this.props.title || !!this.props.subtitle,
          hasRegionAside = this.props.regionAside !== null;
      return !this.props.open ? null : _react2.default.createElement(_reactPortal.Portal, null, _react2.default.createElement(_ModalStyled.ModalStyled, {
        visible: this.props.visible
      }, backdrop, _react2.default.createElement(_OverflowWrapperStyled.OverflowWrapperStyled, {
        customMinWidth: this.props.minWidth,
        hasRegionAside: hasRegionAside,
        regionAsideMaxWidth: this.props.regionAsideMaxWidth,
        regionAsideShow: this.props.regionAsideShow
      }, _react2.default.createElement(_ContentWrapperStyled.ContentWrapperStyled, {
        paddingSize: this.props.paddingSize,
        fullWindowSize: this.props.fullWindowSize,
        customMinWidth: this.props.minWidth,
        hasTransparentBg: this.props.transparentBg,
        hasRegionAside: hasRegionAside,
        regionAsideMaxWidth: this.props.regionAsideMaxWidth,
        regionAsideShow: this.props.regionAsideShow
      }, _react2.default.createElement(_RegionMainStyled.RegionMainStyled, {
        scrollable: this.props.scrollable
      }, closeButton, _react2.default.createElement(_DialogHeading.DialogHeading, {
        title: this.props.title,
        subtitle: this.props.subtitle,
        paddingSize: this.props.paddingSize,
        haveCloseButton: this.props.haveCloseButton
      }), _react2.default.createElement(_DialogContent.DialogContent, {
        flex: this.props.dialogContentFlex,
        paddingSize: this.props.paddingSize,
        scrollable: this.props.scrollable,
        followsHeading: followsHeading
      }, this.props.children), actions), regionAside))));
    }
  }]);

  return _Dialog;
}(_react.Component);

_Dialog.propTypes = propTypes;
_Dialog.defaultProps = defaultProps;
_Dialog.displayName = 'Dialog';
exports.default = (0, _reactackleCore.withTheme)(_Dialog);